<script lang="ts" setup type="text/x-template" id="editorTemplate">
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick, getCurrentInstance } from "vue";
import { getSiteData } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import {
  getKennungValueDisplay,
  getKennungValue,
  getKennungTitle,
  getColumnByKennung,
} from "@/DataHelper";
import { showSnackbar } from "@/UIHelper";
import { calcFunctionNew } from "@/CalcHelperStatic";
import {
  checkBegriff,
  globalsBezeichnung,
  globalsKennung,
  begriffBezeichnung,
} from "@/local";
import CommonBaseButtons from "@/components/common/BaseButtons.vue";
import {
  mountedBase,
  onSave,
  BaseSetup,
  reloadData,
  onDelete,
  createLocalSaveRequest,
} from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";
const emit = defineEmits([
  "back",
  "save",
  "delete",
  "backDelete",
  "queueSaveLocal",
  "localQueued",
  "deletePendingLocal",
]);
const props = defineProps<{
  zeitbereichUebergabe: APIZeitbereich;
  aic: number;
  queueSaveLocal?: boolean;
  checkOneEventPerDay?: (
    von: Date,
    bis: Date,
    employeeAic: any,
    ownAicBewPool: number,
    isAbwesenheit?: boolean,
  ) => boolean;
}>();

let checkDateRange!:
  | ((von: Date, bis: Date, aic: number) => boolean)
  | undefined;
let IsAllDay = ref<boolean>(false);
let color: string = "success";
let stellVertreter: boolean = false;
let disabled = ref<boolean>(false);
let stellBew: boolean = false;
let date: any = "";
let bewilligung: boolean = false;
let stellOffen: boolean = false;
let maName = ref<string>("");
let zeitart = ref<string>("");
let maNameTitel: string = "";
let zeitartTitel: string = "";
let b2 = ref<string>("");
let b2Aic: number = 0;
let b2Titel = ref<number>(0);
let checkStellvertreter = ref<string>("");
let resturlaub = ref<string>("");
let loading: boolean = false;
let loader: any = null;
let aicOffen: number = 0;
let aicEig: number = 0;
let saveVisible = ref<boolean>(true);
let deleteVisible = ref<boolean>(false);
let editErlaubt = ref<boolean>(false);
let saveModell = "WEB_PZE_PlanungDoppelbuchungen";
let tag: Date | null = null;
let step = ref<number>(0);
const saveEmitDelayMs = 200;
const siteData = getSiteData();
let setKey = ref<number>(0);
const componentInstance = getCurrentInstance();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_Planung_Dienstplan",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  pageParams.queryAIC = props.aic;
  pageParams.zeitbereich = props.zeitbereichUebergabe;
  editErlaubt.value = true;
  saveVisible.value = true;
  deleteVisible.value = true;
  step.value = 1;
  if (!checkBegriff("Web_DP_FehlzeitenEditierbar")) {
    deleteVisible.value = false;
    saveVisible.value = false;
    disabled.value = true;
  }
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data) {
    maNameTitel = getKennungTitle("MA", uiData.columns);
    zeitartTitel = getKennungTitle("ZA", uiData.columns);
    maName = getKennungValueDisplay(uiData.data[0], "MA", uiData.columns);
    zeitart = getKennungValueDisplay(uiData.data[0], "ZA", uiData.columns);
    const allDay = getKennungValueDisplay(
      uiData.data[0],
      "B_CALC_FIELD",
      uiData.columns,
    );
    if (allDay === true) {
      IsAllDay.value = true;
    }
    const zuBewilligen = getKennungValueDisplay(
      uiData.data[0],
      "GRANTED",
      uiData.columns,
    );
    if (zuBewilligen === "ja") {
      bewilligung = true;
    }
    const checkBewilligt = getKennungValueDisplay(
      uiData.data[0],
      "b1",
      uiData.columns,
    );
    checkStellvertreter = getKennungValueDisplay(
      uiData.data[0],
      "SV",
      uiData.columns,
    );

    if (checkStellvertreter) {
      stellVertreter = true;
      b2Titel = getKennungTitle("b2", uiData.columns);
      b2 = getKennungValueDisplay(uiData.data[0], "b2", uiData.columns);
      b2Aic = getKennungValue(uiData.data[0], "b2", uiData.columns);
      const column = getColumnByKennung("b2", null, uiData.columns);
      const combo = column.meta.combo;
      aicEig = column.aicEig;
      aicOffen = combo[0].aic;

      if (b2.value === "bewilligt") {
        stellBew = true;
      } else if (checkBewilligt === "offen") {
        stellOffen = true;
      }
    }
    const self = checkBegriff("Web_VG_Selfservice");
    if (!self) {
      const maAIC = getKennungValue(uiData.data[0], "MA", uiData.columns);
      const userAIC = AUApi.Current.user.aic;
      if (maAIC === userAIC) {
        disabled.value = true;
        saveVisible.value = false;
        setKey.value += +1;
      }
    }
  }
});

async function bewDelete() {
  if (
    (siteData?.pendingDienstplanSaveId || siteData?.abwAicAbwesenheiten) &&
    uiData.data[0].aic_Bew_pool === 0
  ) {
    // nur die lokale Änderung verwerfen - der ursprüngliche Datensatz bleibt bestehen
    emit(
      "deletePendingLocal",
      siteData.pendingDienstplanSaveId,
      siteData.abwAicAbwesenheiten,
    );
    return;
  }
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    const success = await onDelete(
      uiData,
      pageParams,
      uiData.data[0].aic_Bew_pool,
      "",
    );
    emit("backDelete");
    if (success) {
      emit("backDelete");
    } else {
      emit("back");
    }
  }
}
function checkValue(evt: any) {
  const value = evt.value;
  const combo = evt.field.meta.combo;
  const textOffen = combo[0].bezeichnung;
  const aktAic = combo[2].aic; // = abgelehnt
  if (value === aktAic) {
    b2Aic = aicOffen;
    b2 = textOffen;
    const spalte = "e" + aicEig;
    for (const i in uiData.data) {
      if (i === spalte) {
        uiData.data[i].iac = b2Aic; // STMM - in eine Zeile kann keine Nummer geschrieben werden...
      }
    }
  }
}

function checkChanged(val: any) {
  if (!disabled.value && checkBegriff("Web_DP_FehlzeitenEditierbar")) {
    saveVisible.value = true;
  }
}
function checkIntersection(skipChanging: boolean = false) {
  if (checkDateRange) {
    const instance = componentInstance;
    if (instance) {
      const dateRange = instance.proxy?.$refs.dateRange as any;
      if (
        dateRange &&
        (skipChanging || dateRange.changing) &&
        dateRange.von &&
        dateRange.bis
      ) {
        const von = dateRange.von;
        let bis = dateRange.bis;
        if (von.valueOf() === bis.valueOf() && dateRange.IsAllDay) {
          bis = bis.addDays(1);
        }
        if (!checkDateRange(von, bis, uiData.data[0].aic_Bew_pool ?? 0)) {
          return false;
        }
      }
    }
  }
  return true;
}

function getDateRangeRefValue() {
  const instance = componentInstance;
  const dateRange = instance?.proxy?.$refs.dateRange as any;
  if (!dateRange?.von) {
    return null;
  }

  let bis = dateRange.bis ?? dateRange.von;
  if (dateRange.von.valueOf() === bis.valueOf() && dateRange.IsAllDay) {
    bis = bis.addDays(1);
  }

  return {
    von: dateRange.von,
    bis,
    IsAllDay: dateRange.IsAllDay ?? IsAllDay.value,
  };
}

function syncDateRangeRefToUiData() {
  const refValue = getDateRangeRefValue();
  if (!refValue) {
    return null;
  }

  const col = uiData.columns.find((c: any) => c.kennung === "vb");
  if (col) {
    uiData.data[0][col.name] = refValue;
  }
  return refValue;
}

function getLocalPreviewDateRange() {
  const refValue = syncDateRangeRefToUiData();
  const vonBis = getKennungValue(uiData.data[0], "vb", uiData.columns);
  const fallbackStart = pageParams.zeitbereich?.von;
  const fallbackEnd = pageParams.zeitbereich?.bis ?? fallbackStart;
  const previewStart = new Date(refValue?.von ?? vonBis?.von ?? fallbackStart);
  const previewEnd = new Date(
    refValue?.bis ?? vonBis?.bis ?? fallbackEnd ?? fallbackStart,
  );
  const fallbackStartDate = new Date(fallbackStart);
  const fallbackEndDate = new Date(fallbackEnd ?? fallbackStart);
  const hasValidPreviewStart =
    !Number.isNaN(previewStart.getTime()) && previewStart.getFullYear() >= 2000;
  const hasValidPreviewEnd =
    !Number.isNaN(previewEnd.getTime()) && previewEnd.getFullYear() >= 2000;
  const startTime = hasValidPreviewStart ? previewStart : fallbackStartDate;
  let endTime = hasValidPreviewEnd ? previewEnd : fallbackEndDate;

  if (endTime.getTime() <= startTime.getTime()) {
    endTime = new Date(startTime);
    endTime.setHours(endTime.getHours() + 1);
  }

  return {
    startTime,
    endTime,
    isAllDay: refValue?.IsAllDay ?? vonBis?.IsAllDay ?? IsAllDay.value,
  };
}

function toPreviewText(value: any): string {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  if (value instanceof Date) {
    return value.toLocaleDateString();
  }
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  if (typeof value === "object") {
    const objectText =
      value.bezeichnung ??
      value.title ??
      value.text ??
      value.label ??
      value.name ??
      value.kennung ??
      value.display ??
      value.value;
    return objectText === value ? "" : toPreviewText(objectText);
  }
  return "";
}

function getPreviewValue(...kennungen: string[]) {
  for (const kennung of kennungen) {
    const displayValue = toPreviewText(
      getKennungValueDisplay(uiData.data[0], kennung, uiData.columns),
    );
    if (displayValue) {
      return displayValue;
    }
    const rawValue = toPreviewText(
      getKennungValue(uiData.data[0], kennung, uiData.columns),
    );
    if (rawValue) {
      return rawValue;
    }
  }
  return "";
}

function getBewilligtStatusIcon(): string {
  // gleiche Konvention wie baseSyncSchedule.vue (checkBewilligtNr aus "Antrag"):
  // 1/true = bewilligt, 2 = abgelehnt, 0/false = offen
  const raw = getKennungValue(uiData.data[0], "b1", uiData.columns);
  if (raw === 1 || raw === true) {
    return "✓";
  }
  if (raw === 2) {
    return "x";
  }
  if (raw === 0 || raw === false) {
    return "■";
  }
  return "";
}

function createLocalPreviewEvent(title: string) {
  const dateRange = getLocalPreviewDateRange();
  const groupId = props.aic ?? pageParams.queryAIC;
  const statusIcon = getBewilligtStatusIcon();
  const zaSubject = getPreviewValue("ZA", "Zeitart", "subject") || title;
  const subject = statusIcon ? `${statusIcon} ${zaSubject}` : zaSubject;
  const memoValue = getPreviewValue("MEMO");

  return {
    Subject: subject,
    IcsSubject: subject,
    StartTime: dateRange.startTime,
    EndTime: dateRange.endTime,
    startDate: dateRange.startTime,
    IsAllDay: dateRange.isAllDay,
    GroupID: groupId,
    idField: groupId,
    id: undefined,
    name: getPreviewValue("MA") || maName.value,
    Location: getPreviewValue("SV"),
    LocationText: getKennungTitle("SV", uiData.columns),
    Description: memoValue,
    Description2: "Lokal vorgemerkt",
    CategoryColor: "#fff8e8",
    abwesenheit: true,
    dienstplan: true,
    abwAicAbwesenheiten: siteData?.abwAicAbwesenheiten,
  };
}

async function onSaveData() {
  if (!checkIntersection()) {
    showSnackbar(
      globalsBezeichnung(Globals.Begriff, "Ueberschneidung", "Überschneidung!"),
    );
    return;
  }
  if (props.checkOneEventPerDay) {
    // pro Tag ist nur eine Abwesenheit pro Mitarbeiter erlaubt
    const dayStart = new Date(pageParams.zeitbereich.von);
    dayStart.setHours(0, 0, 0, 0);
    const dayEnd = new Date(dayStart);
    dayEnd.setDate(dayEnd.getDate() + 1);
    const employeeAic =
      props.aic ?? siteData.aic ?? pageParams.queryAIC ?? siteData.groupID;
    if (
      !props.checkOneEventPerDay(
        dayStart,
        dayEnd,
        employeeAic,
        uiData.data[0]?.aic_Bew_pool ?? 0,
        true,
      )
    ) {
      return;
    }
  }
  const aicAbfAllBez = globalsKennung(Globals.Begriff, "WebPlanungSpeichern");
  const aicAbfAll = aicAbfAllBez.aic;
  let aic: number = pageParams.queryAIC ?? 0;

  if (aicAbfAll) {
    if (props.queueSaveLocal) {
      syncDateRangeRefToUiData();
      const request = createLocalSaveRequest(
        uiData,
        pageParams,
        aicAbfAll,
        pageParams.zeitbereich,
        aic,
      );
      const title =
        `${getPreviewValue("MA") || maName.value || "Mitarbeiter"} ${
          getPreviewValue("ZA") || zeitart.value || "Abwesenheit"
        }`.trim();
      emit("queueSaveLocal", {
        title,
        request,
        previewEvent: createLocalPreviewEvent(title),
        replaceId: siteData?.pendingDienstplanSaveId,
      });
      await nextTick(() => emit("localQueued"));
      return;
    }

    onSave(uiData, pageParams, aicAbfAll, "", undefined, aic)?.then(() => {
      emit("save");
    });
  } else {
    showSnackbar({
      text: "Abfrage nicht gefunden",
      color: "error",
    });
    uiData.showLoading = false;
    return;
  }
}
function onCalculated(args?: any) {
  emit("save");
}
function calcSalden() {
  loading = true;

  const modell = "Web_Resturlaub_per_Stichtag";
  let begriff: any;
  if (modell) {
    begriff = globalsKennung(Globals.Begriff, modell);
  }
  AUApi.Current.postCalc(
    [],
    [],
    begriff.aic,
    pageParams.queryAIC,
    pageParams.zeitbereich,
    0,
    0,
    "",
    successCalc,
    begriff.maxB,
  );
}
function successCalc(res: any) {
  resturlaub = res.data.ergebnis;
  loading = false;
  step.value++;
  return;
}
</script>

<template id="editorTemplate">
  <v-sheet class="dvhDialog">
    <v-card class="pa-0">
      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card
            v-if="!uiData.showLoading"
            class="dvhDialog"
            :loading="uiData.showLoading"
          >
            <v-card-title
              class="subtitle-1 dvhBackground lighten-2"
              v-if="!editErlaubt"
            >
              <div class="white--text e-subject-wrap">
                <div
                  class="e-subject e-text-ellipsis"
                  title="Explosion of Betelgeuse Star"
                >
                  {{ maName }}:
                  {{ zeitart }}
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="e-popup-content">
                <div class="e-date-time">
                  <div class="e-date-time-icon e-icons"></div>
                  <v-container class="custom-event-editor" v-if="editErlaubt">
                    <v-row>
                      <v-col class="fullcol">
                        <EditComboBox
                          kennung="ZA"
                          id="EventType"
                          :name="getKennungTitle('Zeitart', uiData.columns)"
                          style="width: 100%"
                          :disabled="disabled"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="fullcol">
                        <EditDateRange2
                          ref="dateRange"
                          kennung="vb"
                          :IsAllDay="IsAllDay"
                          :disabled="disabled"
                          :showGanztag="true"
                          style="width: 100%"
                        ></EditDateRange2>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-container class="custom-event-editor" v-if="!editErlaubt">
                    <EditDateRange
                      ref="dateRange"
                      kennung="vb"
                      :IsAllDay="IsAllDay"
                      :disabled="true"
                    ></EditDateRange>
                  </v-container>

                  <EditTextArea
                    id="Description"
                    kennung="MEMO"
                    name="Bemerkung"
                    :disabledMounted="true"
                  />
                  <div style="text-align: left" v-if="checkStellvertreter">
                    {{ b2Titel }}: {{ b2 }} von {{ checkStellvertreter }}
                  </div>
                  <EditCheckBox3
                    @seteditvalue="checkValue"
                    :disabled="disabled"
                    @changeValue="checkChanged"
                    kennung="b1"
                  />
                </div>

                <EditTextArea
                  id="VG"
                  kennung="VG"
                  @changeValue="checkChanged"
                  name="Bemerkung"
                  :disabledMounted="false"
                />
              </div>
            </v-card-text>

            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <CommonBaseButtons
                :key="setKey"
                :createVisible="false"
                :refreshVisible="false"
                :deleteVisible="deleteVisible"
                @back="goBack()"
                @delete="bewDelete"
                :saveVisible="saveVisible"
                :backVisible="false"
                @save="onSaveData"
              ></CommonBaseButtons>
            </v-card-actions>
          </v-card>
        </v-window-item>
        <v-window-item :value="2">
          <v-card class="dvhDialog">
            <v-card-title>
              {{
                globalsBezeichnung(
                  Globals.Begriff,
                  "Web_Berechnung_Resturlaub",
                  "Berechnung Resturlaub per Stichtag",
                )
              }}
            </v-card-title>
            <v-card-text>
              <span style="white-space: pre" v-if="resturlaub">
                {{ begriffBezeichnung("Web_Text_Anspruch") }}
                {{ resturlaub }}
              </span></v-card-text
            ></v-card
          >
        </v-window-item>
      </v-window>
      <v-divider class="dvhRot"></v-divider>

      <v-card-actions>
        <v-btn
          v-if="step !== 1"
          :disabled="step === 1"
          variant="text"
          @click="step--"
        >
          <v-icon color="success" x-large>mdi-backspace</v-icon>
        </v-btn>

        <v-btn
          v-if="step !== 2"
          @click="calcSalden()"
          :disabled="step === 2"
          block
          dark
          color="grey lighten-1"
          variant="flat"
          :loading="loading"
          rounded="0"
        >
          <v-icon>mdi-play-circle-outline</v-icon>
          {{
            globalsBezeichnung(
              Globals.Begriff,
              "Web_Text_Anspruch",
              "Resturlaub",
            )
          }}
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<style scoped>
.fullcol {
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  margin: 0px;
}
.dvhDialog {
  padding: 0px;
}
/* @media (max-width: 550px) {
  .dvhDialog {
    padding: 0px;
    width: 300px;
  }
} */
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
